<template>
    <div class="tm-scope tp-input-screen">
        <div class="tp-input-screen__inner">
            <h1 class="fw-bolder title-1">Input Your Skills</h1>

            <div class="w-100 my-2 text-start">
                <div class="tp-input-wrap">
                    <input id="inputSkill" type="text" placeholder="Separate skills with commas or hit enter!"
                            class="w-100 input-white mt-5" :class="{ 'tp-input--error': hasError }"
                            v-model="skill" v-on:keyup.enter="addList()">
                    <FontAwesomeIcon v-if="skill" icon="fa-solid fa-circle-plus" class="check-list" @click="addList()"/>
                </div>
                <div class="tp-pill-row">
                    <Pill
                        v-for="(item,i) in skills" :key="i"
                        :model-value="item" solid
                        @remove="removeList(i)"
                    />
                </div>
            </div>
            <button class="btn-light-blue mt-5" @click="save()">
                <Spinner v-if="spinner" :size="16" />
                <span v-else>Standardize My Skills</span>
            </button>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { faClose,faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useRouter } from 'vue-router';
import { UserInfoApiService } from '@/services/UserInfoApiService';
import Pill from '@/components/Pill.vue';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
    components:{FontAwesomeIcon, Pill, Spinner},
    setup() {
        library.add(faClose,faCirclePlus)
        const router = useRouter()
        const skill = ref()
        const skills = ref([])
        const spinner = ref(false)
        const hasError = ref(false)

        function addList() {
            const items = skill.value.split(',').map(item => item.trim()).filter(item => item !== '');
            items.forEach(item => {
                skills.value.push(item);
            })
            skill.value = ''
        }

        function removeList(index) {
            const test = ref([])
            for (let i = 0; i < skills.value.length; i++) {
                if (i!=index) {
                    test.value.push(skills.value[i])
                }
            }
            skills.value = test.value
        }

        function save() {
            if (skills.value.length!=0) {
                hasError.value = false
                spinner.value = true
                UserInfoApiService.saveSkills(skills.value,localStorage.getItem('user_id')).then((res)=>{
                    if (res.status==200) {
                        localStorage.setItem('skills',1)
                        UserInfoApiService.skills = res.data.processed_skills;
                        spinner.value = false;
                        router.push({name:'view-skills'})
                    }
                })
            }
            else {
                hasError.value = true
            }

        }

        return {
            router,
            skill,
            skills,
            spinner,
            hasError,
            removeList,
            save,
            addList
        }
    },
})
</script>
<style scoped>
.tp-input-screen {
    min-height: 100dvh;
    background-color: var(--tm-canvas);
    padding: 10% 24px 48px;
    position: relative;
}

.tp-input-screen__inner {
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
}

.tp-input-wrap {
    position: relative;
}

.tp-pill-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
}

.tp-input--error {
    box-shadow: 0 0 0 2px var(--tm-gap) !important;
}

.check-list{
    position: absolute;
    right: 10px;
    top: 62%;
    font-size: 25px;
    cursor: pointer;
    color: rgb(24, 201, 24);
}
</style>
